import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import {Translate} from "../../../../config/Translate";

import FileManager from "../FileManager";
import {defaultVariabls} from "../../../../config/index";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class ImgPreviewModal extends React.Component{
    state = {
        open: false
    };
    classes = this.props.classes;
    toggle = () => {
        this.setState({
            open:!this.state.open
        });
    };
    render(){
        let {open} = this.state;
        let {style} = this.props;
        return(
            <>
                <Tooltip title={Translate.imgPreview}>
                    <IconButton size="small" color="primary" onClick={() => this.toggle()} style={style}>
                        <VisibilityRoundedIcon fontSize="small"/>
                    </IconButton>
                </Tooltip>
                <Dialog fullWidth={true} maxWidth={"lg"} open={open} onClose={this.toggle} TransitionComponent={Transition} >
                    <DialogTitle>
                        <IconButton
                            onClick={() => this.toggle()}
                            style={{position:"absolute",left:15,top:15}}
                            size="small"
                        >
                            <CloseRoundedIcon fontSize="small"/>
                        </IconButton>
                        {Translate.imgPreview}
                    </DialogTitle>
                    <IconButton color="inherit" onClick={this.toggle} aria-label="close" style={{position:"absolute",left:5,top:5}}>
                        <CloseIcon />
                    </IconButton>
                    <DialogContent style={{textAlign:"center"}}>
                        <img src={this.props.source} alt="Preview" style={{maxWidth:"100%",padding:20}}/>
                    </DialogContent>
                </Dialog>
            </>
        )
    }
}
export default  withStyles(Styles)(ImgPreviewModal)